/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {GetSendSafelyPackageInformationRequest} from '@cash-web/protos/squareup/privacyvault/service.pb'
import {GetSendSafelyPackageInformationResponse} from '@cash-web/protos/squareup/privacyvault/service.pb'


export const getSendSafelyPackageInformation = (request: GetSendSafelyPackageInformationRequest, options?: CashRequestOptions) => post<GetSendSafelyPackageInformationRequest, GetSendSafelyPackageInformationResponse>("/2.0/cash/get-send-safely-package-information", request, {...options, rejectOnError: true })